import React from "react";
import { Show } from "react-admin";
import { CompanyViewFields } from "./CompanyViewFields";
import { ViewActions } from "../../common/form/ViewActions";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

export const CompanyView = (props: any) => {
  const permissions = useActionPermissions();
  const hasEditPermission =
    (permissions &&
      permissions[permissionNames.admin.companies.main] &&
      permissions[permissionNames.admin.companies.update]) ||
    false;
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Company,
    (x) => x.view
  );

  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Show
        actions={<ViewActions showEditButton={hasEditPermission} />}
        {...props}>
        <CompanyViewFields />
      </Show>
    </FieldPermissionsContext.Provider>
  );
};
